import axios from "axios";
import toast from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const addOoraPlan = (planData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "ADD_OORA_PLAN_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/oora/plan-add`,
        planData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "ADD_OORA_PLAN_SUCCESS", payload: data });
        toast.success("Oora Plan Added successfully!");
      } else {
        dispatch({ type: "ADD_OORA_PLAN_FAILED", payload: data });
      }
      return data;
    } catch (error) {
      dispatch({
        type: "ADD_OORA_PLAN_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const listOoraPlans = (pageData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "LIST_OORA_PLANS_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/oora/plan-list`,
        pageData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "LIST_OORA_PLANS_SUCCESS", payload: data });
      } else {
        dispatch({ type: "LIST_OORA_PLANS_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "LIST_OORA_PLANS_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const updateOoraPlan = (planData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "UPDATE_OORA_PLAN_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/oora/plan-update`,
        planData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_OORA_PLAN_SUCCESS", payload: data });
        toast.success("Oora Plan Updated successfully!");
      } else {
        dispatch({ type: "UPDATE_OORA_PLAN_FAILED", payload: data });
      }
      return data;
    } catch (error) {
      dispatch({
        type: "UPDATE_OORA_PLAN_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const updateOoraPlanStatus = (statusData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "UPDATE_OORA_PLAN_STATUS_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/oora/plan-status`,
        statusData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_OORA_PLAN_STATUS_SUCCESS", payload: data });
        // toast.success("Oora Status Updated successfully!");
      } else {
        dispatch({ type: "UPDATE_OORA_PLAN_STATUS_FAILED", payload: data });
      }
      return data;
    } catch (error) {
      dispatch({
        type: "UPDATE_OORA_PLAN_STATUS_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};